// Copyright (C) 2017-2023 Smart code 203358507

const UpdateDialogHandler = require('./UpdateDialogHandler');

module.exports = UpdateDialogHandler;
